module.exports = __webpack_public_path__ + "img/footer5.54e31efe.jpg";